import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { getMemberActionIsRead } from "../../actions/memberActions";
import { changeEmail } from "../../actions/authActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from "../../validation/is-empty";
import './change.css';

class ChangeEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      error: {},
      showModal: "",
      showModalBackdrop: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount = () => {
    this.props.getMemberActionIsRead();
  };

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({ error: this.props.errors });
    }

    if (this.props.result !== prevProps.result) {
      if (this.props.result.msg && this.props.result.msg === "Change Email OK") {
        this.setState({ showModal: "show", showModalBackdrop: "modal-backdrop show" });
      }
    }
  };

  handleCloseModal() {
    this.setState({ showModal: "", showModalBackdrop: "" });
    this.props.history.push("/members/account");
  }
  
  onClick(e) {
    e.preventDefault();
    const { email } = this.state;

    let error = {};
    if (isEmpty(email)) {
      error.email= "請輸入新的E-mail";
    }

    if (!isEmpty(error)){
      this.setState({ error: error });
    } else {
      this.setState({ error: {} });
      this.props.changeEmail({email});
    }

  };

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { isRead } = this.props;
    const { error, email, showModal, showModalBackdrop } = this.state;
    
    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar showMenuLine={true} isRead={isRead} />
          <div className="colorlib" style={{backgroundColor: "#fafafa", borderBottom: "1px solid #CBCBCB"}}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h1 style={{color: "#000", fontWeight: "700", textAlign: "center", margin: "30px 0px 60px"}}>變更E-Mail</h1>
                  <form>
                      <div className="form-group">
                        <input id="email" name="email" className="form-control" type="email" style={{border: "1.5px solid #000", margin: "0 auto"}} placeholder="輸入新的 E-Mail" required="required" value={email} onChange={this.onChange} />
                        {error.email && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.email}</span> )} 
                      </div>
                      <div className="form-group">
                        <label htmlFor="code" style={{color: "#787878", fontWeight: "600", marginTop: "2rem", marginLeft: "3rem"}}>發送驗證信至您的信箱</label>
                      </div>
                      <div className="form-group">
                        <input type="button" value="變更" className="btn btn-danger btn-block" onClick={this.onClick} />
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModal}`} id="myModal" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
              <div className="modal-dialog" style={{width: "350px",margin: "250px auto"}}>
                  <div className="modal-content"> 
                      <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                          <h3>Email 已變更完成</h3>
                          <p>請到您的信箱啟動驗證信件，10分鐘有效</p>
                      </div>
                      <div className="modal-footer" style={{textAlign: "center", border: "0"}}>
                          <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModal}>完成</button>
                      </div>
                  </div>
              </div>
            </div>
          </div>

          <Footer />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

ChangeEmail.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  changeEmail: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  errors: state.errors,
  result: state.auth.changeEmailResult
});

export default connect(mapStateToProps, { changeEmail, getMemberActionIsRead })(ChangeEmail);